export const MAX_EQUATION_NODES = 64;
export const MAX_ABSOLUTE_INPUT_VALUE = 100;
export const MAX_EXPRESSION_SOURCE_LENGTH = 100;
export const MIN_MATRIX_DURATION_MS = 100;
export const MAX_MATRIX_DURATION_MS = 3_000;
export const MAX_MATRIX_LABEL_LENGTH = 2;
export const MAX_VECTOR_LABEL_LENGTH = 4;
export const MATRIX_LABEL_PATTERN = /^[A-Z]{1,2}$/;
export const VECTOR_LABEL_PATTERN = /^v[1-9][0-9]{0,2}$/;
export const VECTOR_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;

export function matrixDurationMs(value: number): number {
  if (
    !Number.isFinite(value) ||
    value < MIN_MATRIX_DURATION_MS ||
    value > MAX_MATRIX_DURATION_MS
  )
    throw new Error("Invalid matrix duration");
  return value;
}
